"use strict";

(function () {
  class ProductStickyBarController {
    constructor(root) {
      this.root = root;
      this.mainContainer = root.querySelector(".js-product-main__main");
      this.handleIntersection = this.handleIntersection.bind(this);
      this.handleMutations = this.handleMutations.bind(this);
      this.handleStickyClick = this.handleStickyClick.bind(this);
      this.handleStickyChange = this.handleStickyChange.bind(this);

      this.mutationObserver = new MutationObserver(this.handleMutations);
      if (this.mainContainer) {
        this.mutationObserver.observe(this.mainContainer, { childList: true, subtree: true });
      }

      this.refresh();
    }

    disconnect() {
      if (this.stickyBar) {
        this.stickyBar.removeEventListener("click", this.handleStickyClick);
        this.stickyBar.removeEventListener("change", this.handleStickyChange);
      }
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    handleMutations() {
      this.mainContainer = this.root.querySelector(".js-product-main__main");
      this.refresh();
    }

    refresh() {
      this.stickyBar = this.stickyBar || this.root.querySelector(".js-product-main__sticky-bar");
      this.trigger = this.root.querySelector(".js-product-main__sticky-trigger");
      this.proxySubmitButton = this.root.querySelector(
        ".c-product-main__button-wrapper--desktop .c-product-main__form-submit:not(.is-hidden)"
      );
      this.proxyWishlistButton = this.root.querySelector(
        ".c-product-main__button-wrapper--desktop .js-product-main__wishlist"
      );
      this.stickyWishlistButton = this.root.querySelector(".js-product-main__sticky-wishlist");
      this.stickyVariantSelect = this.stickyBar
        ? this.stickyBar.querySelector(".js-product-main__sticky-variant-select")
        : null;
      this.stickyPrice = this.stickyBar ? this.stickyBar.querySelector(".c-product-main__sticky-bar-price") : null;
      this.stickySubmitButton = this.stickyBar
        ? this.stickyBar.querySelector(".js-product-main__sticky-submit")
        : null;
      this.selectedVariantInput = this.root.querySelector(".js-product-main__option-input:checked");
      this.priceSource = this.root.querySelector(".c-product-main__price");

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }

      if (!this.stickyBar || !this.trigger) {
        return;
      }

      if (this.stickyBar.parentNode !== document.body) {
        this.stickyBar.removeEventListener("click", this.handleStickyClick);
        this.stickyBar.removeEventListener("change", this.handleStickyChange);
        document.body.appendChild(this.stickyBar);
        this.stickyBar.addEventListener("click", this.handleStickyClick);
        this.stickyBar.addEventListener("change", this.handleStickyChange);
      }

      if (this.stickyWishlistButton && this.proxyWishlistButton) {
        this.stickyWishlistButton.classList.toggle(
          "is-active",
          this.proxyWishlistButton.classList.contains("is-active")
        );
      }

      if (this.stickyVariantSelect && this.selectedVariantInput) {
        this.stickyVariantSelect.value = this.selectedVariantInput.dataset.variantId || "";
      }

      if (this.stickyPrice && this.priceSource) {
        this.stickyPrice.textContent = this.priceSource.textContent.trim();
      }

      if (this.stickySubmitButton && this.proxySubmitButton) {
        this.stickySubmitButton.textContent = this.proxySubmitButton.textContent.trim();
        this.stickySubmitButton.classList.toggle("disabled", this.proxySubmitButton.classList.contains("disabled"));
      }

      this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
        threshold: 0.15,
      });
      this.intersectionObserver.observe(this.trigger);
    }

    handleIntersection(entries) {
      const entry = entries[0];
      if (!entry || !this.stickyBar) {
        return;
      }

      const shouldShow = !entry.isIntersecting;
      this.stickyBar.classList.toggle("is-active", shouldShow);
      this.stickyBar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    }

    handleStickyClick(event) {
      const sizeGuideButton = event.target.closest(".js-product-main__sticky-size-guide");
      if (sizeGuideButton) {
        event.preventDefault();
        if (window.PubSub && typeof window.PubSub.publish === "function") {
          window.PubSub.publish("open-size-guide-drawer");
        }
        return;
      }

      const stickySubmitButton = event.target.closest(".js-product-main__sticky-submit");
      if (stickySubmitButton) {
        event.preventDefault();
        if (this.proxySubmitButton) {
          this.proxySubmitButton.click();
        }
        return;
      }

      const stickyWishlistButton = event.target.closest(".js-product-main__sticky-wishlist");
      if (stickyWishlistButton) {
        event.preventDefault();
        if (this.proxyWishlistButton) {
          this.proxyWishlistButton.click();
        }
      }
    }

    handleStickyChange(event) {
      const variantSelect = event.target.closest(".js-product-main__sticky-variant-select");
      if (!variantSelect) {
        return;
      }

      const variantId = variantSelect.value;
      if (!variantId) {
        return;
      }

      const sourceInput = this.root.querySelector(`.js-product-main__option-input[data-variant-id="${variantId}"]`);
      if (!sourceInput) {
        return;
      }

      sourceInput.checked = true;
      sourceInput.setAttribute("checked", "true");
      sourceInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  const controllers = new WeakMap();

  const initializeStickyBars = () => {
    document.querySelectorAll("c-product-main").forEach((root) => {
      if (!controllers.has(root)) {
        controllers.set(root, new ProductStickyBarController(root));
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeStickyBars, { once: true });
  } else {
    initializeStickyBars();
  }
})();
